export enum BarType
{
    Without = 0,
    Text,
    Rss
}